import { Box } from '@/components/Common/Box';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const GooglePayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.GOOGLE_PAY}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.GOOGLE_PAY)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.GOOGLE_PAY)} alt="google-pay" />
    </Box>
  );
};
